export type CurrentEmergencyProps = {
	wrap?: (children?: React.ReactNode) => React.ReactNode
}

export const CurrentEmergency = ({wrap = (children) => children}: CurrentEmergencyProps) => {
	const emergency: React.ReactNode | undefined = undefined;
	// <UkraineNotWorking/>

	return emergency && wrap(emergency);
}